import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import formatUrlSearchParameters from '@/libraries/formatters/format-url-search-parameters';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryPickupPointData = Content.Components['PickupPointModuleDto'];

interface UseQueryPickupPointOptions {
  enabled?: boolean;
  initialData?: UseQueryPickupPointData;
  parameters: Content.Components['IBookingHeadlessParameters'] & {
    id: string;
    pageId: string;
  };
}

const useQueryPickupPoint = ({
  enabled = true,
  initialData,
  parameters,
}: UseQueryPickupPointOptions) => {
  const locale = getLocale();

  const query = useQuery<UseQueryPickupPointData>(
    [QueryId.PICKUP_POINT, parameters, locale],
    async () => {
      const baseUrl = '/api/content-modules/pickup-point';
      const queryParameters = formatUrlSearchParameters(parameters);

      const fetchResponse = await fetch(
        `${baseUrl}?${queryParameters.toString()}`,
        {
          headers: {
            ['Accept-Language']: getCulture(locale),
            ['Content-Type']: 'application/json',
          },
          method: 'GET',
        },
      )
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQueryPickupPoint', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!parameters && enabled,
      initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQueryPickupPoint;
